import { motion } from 'framer-motion';
import { useInView } from 'react-intersection-observer';

const springTransition = {
  type: 'spring',
  stiffness: 80,
  damping: 20,
};

export default function Stats() {
  const [ref, inView] = useInView({
    triggerOnce: true,
    threshold: 0.1,
  });

  const stats = [
    { number: '200+', label: 'Developers Placed', icon: 'ri-user-follow-line' },
    { number: '50+', label: 'Active Clients', icon: 'ri-building-line' },
    { number: '10+', label: 'Industries Served', icon: 'ri-global-line' },
    { number: '5', label: 'Day Avg. Onboarding', icon: 'ri-time-line' },
  ];

  return (
    <section id="stats" className="py-14 md:py-20 bg-gray-50 relative overflow-hidden" ref={ref}>
      {/* Decorative Elements */}
      <div className="absolute inset-0 overflow-hidden">
        <div className="absolute top-0 left-1/4 w-96 h-96 bg-primary-500/10 rounded-full blur-3xl"></div>
        <div className="absolute bottom-0 right-1/4 w-96 h-96 bg-amber-500/10 rounded-full blur-3xl"></div>
      </div>

      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Stats content removed */}
      </div>
    </section>
  );
}